import type { ColumnDefinition } from '../types/column.type';

/**
 * rowNumber 컬럼을 추가합니다
 */
export const addRowNumberColumn = (
  columns: ColumnDefinition[]
): ColumnDefinition[] => {
  const found = columns.find(column => column.field === 'rowNumber');
  if (found) return columns;

  return [
    {
      field: 'rowNumber',
      type: 'number',
      name: '순번',
      style: {
        columnClass: 'w-[5rem] justify-center',
        cellClass: 'text-center',
      },
    },
    ...columns,
  ];
};

/**
 * checkbox 컬럼을 추가합니다
 */
export const addCheckboxColumn = (
  columns: ColumnDefinition[]
): ColumnDefinition[] => {
  const found = columns.find(column => column.field === 'checkbox');
  if (found) return columns;

  return [
    {
      field: 'checkbox',
      type: 'checkbox',
      name: '',
    },
    ...columns,
  ];
};
